module.exports = __webpack_public_path__ + "static/media/vision_2circle.1300e7ae.png";